
























































import { Component, Prop, Vue } from 'vue-property-decorator';
import checkMobile from '@/mixins/checkMobile';
import ExtButton from '@/components/ext/Button.vue';
import BlogArticle from '@/components/parts/blog/article';
import BlogArticleItem from '@/components/parts/blog/list/components/Item.vue';
import BlogAside from '@/components/parts/blog/aside';
import { NumberedString } from './types';

@Component({
  components: {
    ExtButton,
    BlogArticle,
    BlogArticleItem,
    BlogAside,
  },

  mixins: [checkMobile],
})
export default class ComponentsPageBlogArticle extends Vue {
  // Props
  @Prop({ type: String, default: '' })
  title: string;

  @Prop({ type: String, default: '' })
  text: string;

  @Prop({ type: String, default: '' })
  middleThumb: string;

  @Prop({ type: Array, default: () => [] })
  videos: Array<any>;

  @Prop({ type: Boolean, default: false })
  isReview: boolean;

  @Prop({ type: [String, Number], default: null })
  id: NumberedString;

  @Prop({ type: [String, Number], default: null })
  view: NumberedString;

  @Prop({ type: [String, Number], default: null })
  comments: NumberedString;

  @Prop({ type: [String, Number], default: null })
  prevId: NumberedString;

  @Prop({ type: [String, Number], default: null })
  nextId: NumberedString;

  @Prop({ type: Array, default: () => [] })
  events: Array<any>;

  @Prop({ type: Array, default: () => [] })
  articles: Array<any>;

  @Prop({ type: String, default: '' })
  event_type: String;

  @Prop({ type: String, default: '' })
  cop_multi_name: String;

  // computed
  get blogLink() {
    return { name: 'blog' };
  }

  get hasPrevDisabled() {
    return !this.prevId;
  }

  get prevBtnColor() {
    return this.hasPrevDisabled ? 'disabled' : 'default';
  }

  get hasNextDisabled() {
    return !this.nextId;
  }

  get nextBtnColor() {
    return this.hasNextDisabled ? 'disabled' : 'green';
  }

  get isPhoneOrTablet() {
    return (this as any).checkMobile.windowWidth <= 640;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/page/blog/article/Arcitle.vue